import { matchingEngineApi } from '../matching-engine.utils';
import { useQuery } from 'react-query';
import { useSession } from 'common/hooks';

export const useGetPastSkillFeedbacks = (profileId: string, skillId: string) => {
  const { account: user } = useSession();
  const getPastSkillFeedbacks = () => {
    const params = {
      profileId,
      skillId,
    };

    return matchingEngineApi.get(`past-skill-feedbacks`, { params });
  };

  const queryKey = [
    'matching-engine',
    user?.organizationId,
    profileId,
    skillId,
    'past-feedbacks',
  ];
  const queryResponse = useQuery(queryKey, getPastSkillFeedbacks, {
    enabled: !!profileId,
  });
  return {
    ...queryResponse,
    data: queryResponse.data?.data,
  };
};
